/* @generated */
import { FileAudioLarge } from "../icons/file-audio-large.esm.js";
import { FileAudioSmall } from "../icons/file-audio-small.esm.js";
import { FileAutodeskLarge } from "../icons/file-autodesk-large.esm.js";
import { FileAutodeskSmall } from "../icons/file-autodesk-small.esm.js";
import { FileCadLarge } from "../icons/file-cad-large.esm.js";
import { FileCadSmall } from "../icons/file-cad-small.esm.js";
import { FileCodeLarge } from "../icons/file-code-large.esm.js";
import { FileCodeSmall } from "../icons/file-code-small.esm.js";
import { FileDiscLarge } from "../icons/file-disc-large.esm.js";
import { FileDiscSmall } from "../icons/file-disc-small.esm.js";
import { FileDocumentLarge } from "../icons/file-document-large.esm.js";
import { FileDocumentSmall } from "../icons/file-document-small.esm.js";
import { FileExcelLarge } from "../icons/file-excel-large.esm.js";
import { FileExcelSmall } from "../icons/file-excel-small.esm.js";
import { FileExeLarge } from "../icons/file-exe-large.esm.js";
import { FileExeSmall } from "../icons/file-exe-small.esm.js";
import { FileFlashLarge } from "../icons/file-flash-large.esm.js";
import { FileFlashSmall } from "../icons/file-flash-small.esm.js";
import { FileFontLarge } from "../icons/file-font-large.esm.js";
import { FileFontSmall } from "../icons/file-font-small.esm.js";
import { FileFramerLarge } from "../icons/file-framer-large.esm.js";
import { FileFramerSmall } from "../icons/file-framer-small.esm.js";
import { FileGamingLarge } from "../icons/file-gaming-large.esm.js";
import { FileGamingSmall } from "../icons/file-gaming-small.esm.js";
import { FileGDocLarge } from "../icons/file-g-doc-large.esm.js";
import { FileGDocSmall } from "../icons/file-g-doc-small.esm.js";
import { FileGSheetLarge } from "../icons/file-g-sheet-large.esm.js";
import { FileGSheetSmall } from "../icons/file-g-sheet-small.esm.js";
import { FileGSlidesLarge } from "../icons/file-g-slides-large.esm.js";
import { FileGSlidesSmall } from "../icons/file-g-slides-small.esm.js";
import { FileIllustratorLarge } from "../icons/file-illustrator-large.esm.js";
import { FileIllustratorSmall } from "../icons/file-illustrator-small.esm.js";
import { FileImageLarge } from "../icons/file-image-large.esm.js";
import { FileImageSmall } from "../icons/file-image-small.esm.js";
import { FileLinkLarge } from "../icons/file-link-large.esm.js";
import { FileLinkSmall } from "../icons/file-link-small.esm.js";
import { FilePackageLarge } from "../icons/file-package-large.esm.js";
import { FilePackageSmall } from "../icons/file-package-small.esm.js";
import { FilePaperLarge } from "../icons/file-paper-large.esm.js";
import { FilePaperSmall } from "../icons/file-paper-small.esm.js";
import { FilePdfLarge } from "../icons/file-pdf-large.esm.js";
import { FilePdfSmall } from "../icons/file-pdf-small.esm.js";
import { FilePhotoshopLarge } from "../icons/file-photoshop-large.esm.js";
import { FilePhotoshopSmall } from "../icons/file-photoshop-small.esm.js";
import { FilePowerpointLarge } from "../icons/file-powerpoint-large.esm.js";
import { FilePowerpointSmall } from "../icons/file-powerpoint-small.esm.js";
import { FilePremiereLarge } from "../icons/file-premiere-large.esm.js";
import { FilePremiereSmall } from "../icons/file-premiere-small.esm.js";
import { FilePresentationLarge } from "../icons/file-presentation-large.esm.js";
import { FilePresentationSmall } from "../icons/file-presentation-small.esm.js";
import { FileShortcutLarge } from "../icons/file-shortcut-large.esm.js";
import { FileShortcutSmall } from "../icons/file-shortcut-small.esm.js";
import { FileSketchLarge } from "../icons/file-sketch-large.esm.js";
import { FileSketchSmall } from "../icons/file-sketch-small.esm.js";
import { FileSpreadsheetLarge } from "../icons/file-spreadsheet-large.esm.js";
import { FileSpreadsheetSmall } from "../icons/file-spreadsheet-small.esm.js";
import { FileTextLarge } from "../icons/file-text-large.esm.js";
import { FileTextSmall } from "../icons/file-text-small.esm.js";
import { FileVideoLarge } from "../icons/file-video-large.esm.js";
import { FileVideoSmall } from "../icons/file-video-small.esm.js";
import { FileWordLarge } from "../icons/file-word-large.esm.js";
import { FileWordSmall } from "../icons/file-word-small.esm.js";
import { FileZipLarge } from "../icons/file-zip-large.esm.js";
import { FileZipSmall } from "../icons/file-zip-small.esm.js";
import { FileUnknownSmall } from "../icons/file-unknown-small.esm.js";
import { FileUnknownLarge } from "../icons/file-unknown-large.esm.js";
const EXTENSIONS_MAP = {
  "3ga-large": FileAudioLarge,
  "3ga-small": FileAudioSmall,
  "aac-large": FileAudioLarge,
  "aac-small": FileAudioSmall,
  "aif-large": FileAudioLarge,
  "aif-small": FileAudioSmall,
  "aiff-large": FileAudioLarge,
  "aiff-small": FileAudioSmall,
  "amr-large": FileAudioLarge,
  "amr-small": FileAudioSmall,
  "au-large": FileAudioLarge,
  "au-small": FileAudioSmall,
  "iff-large": FileAudioLarge,
  "iff-small": FileAudioSmall,
  "m3u-large": FileAudioLarge,
  "m3u-small": FileAudioSmall,
  "m4a-large": FileAudioLarge,
  "m4a-small": FileAudioSmall,
  "mid-large": FileAudioLarge,
  "mid-small": FileAudioSmall,
  "mp3-large": FileAudioLarge,
  "mp3-small": FileAudioSmall,
  "mpa-large": FileAudioLarge,
  "mpa-small": FileAudioSmall,
  "oga-large": FileAudioLarge,
  "oga-small": FileAudioSmall,
  "ogg-large": FileAudioLarge,
  "ogg-small": FileAudioSmall,
  "ra-large": FileAudioLarge,
  "ra-small": FileAudioSmall,
  "wav-large": FileAudioLarge,
  "wav-small": FileAudioSmall,
  "wma-large": FileAudioLarge,
  "wma-small": FileAudioSmall,
  "aifc-large": FileAudioLarge,
  "aifc-small": FileAudioSmall,
  "dwg-large": FileAutodeskLarge,
  "dwg-small": FileAutodeskSmall,
  "dxf-large": FileAutodeskLarge,
  "dxf-small": FileAutodeskSmall,
  "3dm-large": FileCadLarge,
  "3dm-small": FileCadSmall,
  "3ds-large": FileCadLarge,
  "3ds-small": FileCadSmall,
  "ive-large": FileCadLarge,
  "ive-small": FileCadSmall,
  "max-large": FileCadLarge,
  "max-small": FileCadSmall,
  "obj-large": FileCadLarge,
  "obj-small": FileCadSmall,
  "as-large": FileCodeLarge,
  "as-small": FileCodeSmall,
  "as3-large": FileCodeLarge,
  "as3-small": FileCodeSmall,
  "asm-large": FileCodeLarge,
  "asm-small": FileCodeSmall,
  "aspx-large": FileCodeLarge,
  "aspx-small": FileCodeSmall,
  "bat-large": FileCodeLarge,
  "bat-small": FileCodeSmall,
  "c-large": FileCodeLarge,
  "c-small": FileCodeSmall,
  "cc-large": FileCodeLarge,
  "cc-small": FileCodeSmall,
  "cmake-large": FileCodeLarge,
  "cmake-small": FileCodeSmall,
  "coffee-large": FileCodeLarge,
  "coffee-small": FileCodeSmall,
  "cpp-large": FileCodeLarge,
  "cpp-small": FileCodeSmall,
  "cs-large": FileCodeLarge,
  "cs-small": FileCodeSmall,
  "css-large": FileCodeLarge,
  "css-small": FileCodeSmall,
  "cxx-large": FileCodeLarge,
  "cxx-small": FileCodeSmall,
  "diff-large": FileCodeLarge,
  "diff-small": FileCodeSmall,
  "erb-large": FileCodeLarge,
  "erb-small": FileCodeSmall,
  "erl-large": FileCodeLarge,
  "erl-small": FileCodeSmall,
  "groovy-large": FileCodeLarge,
  "groovy-small": FileCodeSmall,
  "gry-large": FileCodeLarge,
  "gry-small": FileCodeSmall,
  "h-large": FileCodeLarge,
  "h-small": FileCodeSmall,
  "haml-large": FileCodeLarge,
  "haml-small": FileCodeSmall,
  "hh-large": FileCodeLarge,
  "hh-small": FileCodeSmall,
  "hpp-large": FileCodeLarge,
  "hpp-small": FileCodeSmall,
  "htm-large": FileCodeLarge,
  "htm-small": FileCodeSmall,
  "html-large": FileCodeLarge,
  "html-small": FileCodeSmall,
  "hxx-large": FileCodeLarge,
  "hxx-small": FileCodeSmall,
  "java-large": FileCodeLarge,
  "java-small": FileCodeSmall,
  "js-large": FileCodeLarge,
  "js-small": FileCodeSmall,
  "json-large": FileCodeLarge,
  "json-small": FileCodeSmall,
  "jsx-large": FileCodeLarge,
  "jsx-small": FileCodeSmall,
  "less-large": FileCodeLarge,
  "less-small": FileCodeSmall,
  "lst-large": FileCodeLarge,
  "lst-small": FileCodeSmall,
  "m-large": FileCodeLarge,
  "m-small": FileCodeSmall,
  "make-large": FileCodeLarge,
  "make-small": FileCodeSmall,
  "ml-large": FileCodeLarge,
  "ml-small": FileCodeSmall,
  "mm-large": FileCodeLarge,
  "mm-small": FileCodeSmall,
  "out-large": FileCodeLarge,
  "out-small": FileCodeSmall,
  "patch-large": FileCodeLarge,
  "patch-small": FileCodeSmall,
  "php-large": FileCodeLarge,
  "php-small": FileCodeSmall,
  "pl-large": FileCodeLarge,
  "pl-small": FileCodeSmall,
  "plist-large": FileCodeLarge,
  "plist-small": FileCodeSmall,
  "properties-large": FileCodeLarge,
  "properties-small": FileCodeSmall,
  "py-large": FileCodeLarge,
  "py-small": FileCodeSmall,
  "rb-large": FileCodeLarge,
  "rb-small": FileCodeSmall,
  "sass-large": FileCodeLarge,
  "sass-small": FileCodeSmall,
  "scala-large": FileCodeLarge,
  "scala-small": FileCodeSmall,
  "scm-large": FileCodeLarge,
  "scm-small": FileCodeSmall,
  "script-large": FileCodeLarge,
  "script-small": FileCodeSmall,
  "scss-large": FileCodeLarge,
  "scss-small": FileCodeSmall,
  "sh-large": FileCodeLarge,
  "sh-small": FileCodeSmall,
  "sln-large": FileCodeLarge,
  "sln-small": FileCodeSmall,
  "sml-large": FileCodeLarge,
  "sml-small": FileCodeSmall,
  "sql-large": FileCodeLarge,
  "sql-small": FileCodeSmall,
  "ts-large": FileCodeLarge,
  "ts-small": FileCodeSmall,
  "vb-large": FileCodeLarge,
  "vb-small": FileCodeSmall,
  "vcproj-large": FileCodeLarge,
  "vcproj-small": FileCodeSmall,
  "vi-large": FileCodeLarge,
  "vi-small": FileCodeSmall,
  "vim-large": FileCodeLarge,
  "vim-small": FileCodeSmall,
  "xml-large": FileCodeLarge,
  "xml-small": FileCodeSmall,
  "yaml-large": FileCodeLarge,
  "yaml-small": FileCodeSmall,
  "yml-large": FileCodeLarge,
  "yml-small": FileCodeSmall,
  "asp-large": FileCodeLarge,
  "asp-small": FileCodeSmall,
  "cer-large": FileCodeLarge,
  "cer-small": FileCodeSmall,
  "cfm-large": FileCodeLarge,
  "cfm-small": FileCodeSmall,
  "class-large": FileCodeLarge,
  "class-small": FileCodeSmall,
  "csr-large": FileCodeLarge,
  "csr-small": FileCodeSmall,
  "dtd-large": FileCodeLarge,
  "dtd-small": FileCodeSmall,
  "jsp-large": FileCodeLarge,
  "jsp-small": FileCodeSmall,
  "kml-large": FileCodeLarge,
  "kml-small": FileCodeSmall,
  "lua-large": FileCodeLarge,
  "lua-small": FileCodeSmall,
  "rss-large": FileCodeLarge,
  "rss-small": FileCodeSmall,
  "vcxproj-large": FileCodeLarge,
  "vcxproj-small": FileCodeSmall,
  "wsf-large": FileCodeLarge,
  "wsf-small": FileCodeSmall,
  "xcodeproj-large": FileCodeLarge,
  "xcodeproj-small": FileCodeSmall,
  "xhtml-large": FileCodeLarge,
  "xhtml-small": FileCodeSmall,
  "swift-large": FileCodeLarge,
  "swift-small": FileCodeSmall,
  "vue-large": FileCodeLarge,
  "vue-small": FileCodeSmall,
  "tsx-large": FileCodeLarge,
  "tsx-small": FileCodeSmall,
  "svelte-large": FileCodeLarge,
  "svelte-small": FileCodeSmall,
  "dmg-large": FileDiscLarge,
  "dmg-small": FileDiscSmall,
  "iso-large": FileDiscLarge,
  "iso-small": FileDiscSmall,
  "mdf-large": FileDiscLarge,
  "mdf-small": FileDiscSmall,
  "toast-large": FileDiscLarge,
  "toast-small": FileDiscSmall,
  "vcd-large": FileDiscLarge,
  "vcd-small": FileDiscSmall,
  "odt-large": FileDocumentLarge,
  "odt-small": FileDocumentSmall,
  "pages-large": FileDocumentLarge,
  "pages-small": FileDocumentSmall,
  "ods-large": FileExcelLarge,
  "ods-small": FileExcelSmall,
  "xls-large": FileExcelLarge,
  "xls-small": FileExcelSmall,
  "xlsb-large": FileExcelLarge,
  "xlsb-small": FileExcelSmall,
  "xlsm-large": FileExcelLarge,
  "xlsm-small": FileExcelSmall,
  "xlsx-large": FileExcelLarge,
  "xlsx-small": FileExcelSmall,
  "xsd-large": FileExcelLarge,
  "xsd-small": FileExcelSmall,
  "xsl-large": FileExcelLarge,
  "xsl-small": FileExcelSmall,
  "xrl-large": FileExcelLarge,
  "xrl-small": FileExcelSmall,
  "app-large": FileExeLarge,
  "app-small": FileExeSmall,
  "dll-large": FileExeLarge,
  "dll-small": FileExeSmall,
  "exe-large": FileExeLarge,
  "exe-small": FileExeSmall,
  "pif-large": FileExeLarge,
  "pif-small": FileExeSmall,
  "fla-large": FileFlashLarge,
  "fla-small": FileFlashSmall,
  "swf-large": FileFlashLarge,
  "swf-small": FileFlashSmall,
  "fnt-large": FileFontLarge,
  "fnt-small": FileFontSmall,
  "fon-large": FileFontLarge,
  "fon-small": FileFontSmall,
  "otf-large": FileFontLarge,
  "otf-small": FileFontSmall,
  "ttf-large": FileFontLarge,
  "ttf-small": FileFontSmall,
  "woff-large": FileFontLarge,
  "woff-small": FileFontSmall,
  "woff2-large": FileFontLarge,
  "woff2-small": FileFontSmall,
  "framerx-large": FileFramerLarge,
  "framerx-small": FileFramerSmall,
  "dem-large": FileGamingLarge,
  "dem-small": FileGamingSmall,
  "gam-large": FileGamingLarge,
  "gam-small": FileGamingSmall,
  "nes-large": FileGamingLarge,
  "nes-small": FileGamingSmall,
  "rom-large": FileGamingLarge,
  "rom-small": FileGamingSmall,
  "sav-large": FileGamingLarge,
  "sav-small": FileGamingSmall,
  "gdoc-large": FileGDocLarge,
  "gdoc-small": FileGDocSmall,
  "gsheet-large": FileGSheetLarge,
  "gsheet-small": FileGSheetSmall,
  "gslides-large": FileGSlidesLarge,
  "gslides-small": FileGSlidesSmall,
  "ai-large": FileIllustratorLarge,
  "ai-small": FileIllustratorSmall,
  "3fr-large": FileImageLarge,
  "3fr-small": FileImageSmall,
  "ari-large": FileImageLarge,
  "ari-small": FileImageSmall,
  "arw-large": FileImageLarge,
  "arw-small": FileImageSmall,
  "bay-large": FileImageLarge,
  "bay-small": FileImageSmall,
  "bmp-large": FileImageLarge,
  "bmp-small": FileImageSmall,
  "cap-large": FileImageLarge,
  "cap-small": FileImageSmall,
  "cr2-large": FileImageLarge,
  "cr2-small": FileImageSmall,
  "crw-large": FileImageLarge,
  "crw-small": FileImageSmall,
  "dcr-large": FileImageLarge,
  "dcr-small": FileImageSmall,
  "dcs-large": FileImageLarge,
  "dcs-small": FileImageSmall,
  "dng-large": FileImageLarge,
  "dng-small": FileImageSmall,
  "drf-large": FileImageLarge,
  "drf-small": FileImageSmall,
  "eip-large": FileImageLarge,
  "eip-small": FileImageSmall,
  "erf-large": FileImageLarge,
  "erf-small": FileImageSmall,
  "fff-large": FileImageLarge,
  "fff-small": FileImageSmall,
  "gif-large": FileImageLarge,
  "gif-small": FileImageSmall,
  "heic-large": FileImageLarge,
  "heic-small": FileImageSmall,
  "heif-large": FileImageLarge,
  "heif-small": FileImageSmall,
  "iiq-large": FileImageLarge,
  "iiq-small": FileImageSmall,
  "jpeg-large": FileImageLarge,
  "jpeg-small": FileImageSmall,
  "jpg-large": FileImageLarge,
  "jpg-small": FileImageSmall,
  "k25-large": FileImageLarge,
  "k25-small": FileImageSmall,
  "kdc-large": FileImageLarge,
  "kdc-small": FileImageSmall,
  "mef-large": FileImageLarge,
  "mef-small": FileImageSmall,
  "mos-large": FileImageLarge,
  "mos-small": FileImageSmall,
  "mrw-large": FileImageLarge,
  "mrw-small": FileImageSmall,
  "nef-large": FileImageLarge,
  "nef-small": FileImageSmall,
  "nrw-large": FileImageLarge,
  "nrw-small": FileImageSmall,
  "obm-large": FileImageLarge,
  "obm-small": FileImageSmall,
  "odg-large": FileImageLarge,
  "odg-small": FileImageSmall,
  "orf-large": FileImageLarge,
  "orf-small": FileImageSmall,
  "pef-large": FileImageLarge,
  "pef-small": FileImageSmall,
  "png-large": FileImageLarge,
  "png-small": FileImageSmall,
  "ppm-large": FileImageLarge,
  "ppm-small": FileImageSmall,
  "ptx-large": FileImageLarge,
  "ptx-small": FileImageSmall,
  "pxn-large": FileImageLarge,
  "pxn-small": FileImageSmall,
  "r3d-large": FileImageLarge,
  "r3d-small": FileImageSmall,
  "raf-large": FileImageLarge,
  "raf-small": FileImageSmall,
  "raw-large": FileImageLarge,
  "raw-small": FileImageSmall,
  "rw2-large": FileImageLarge,
  "rw2-small": FileImageSmall,
  "rwl-large": FileImageLarge,
  "rwl-small": FileImageSmall,
  "rwz-large": FileImageLarge,
  "rwz-small": FileImageSmall,
  "sr2-large": FileImageLarge,
  "sr2-small": FileImageSmall,
  "srf-large": FileImageLarge,
  "srf-small": FileImageSmall,
  "srw-large": FileImageLarge,
  "srw-small": FileImageSmall,
  "svg-large": FileImageLarge,
  "svg-small": FileImageSmall,
  "svgz-large": FileImageLarge,
  "svgz-small": FileImageSmall,
  "tif-large": FileImageLarge,
  "tif-small": FileImageSmall,
  "tiff-large": FileImageLarge,
  "tiff-small": FileImageSmall,
  "wbmp-large": FileImageLarge,
  "wbmp-small": FileImageSmall,
  "webp-large": FileImageLarge,
  "webp-small": FileImageSmall,
  "x3f-large": FileImageLarge,
  "x3f-small": FileImageSmall,
  "icns-large": FileImageLarge,
  "icns-small": FileImageSmall,
  "ico-large": FileImageLarge,
  "ico-small": FileImageSmall,
  "ithmb-large": FileImageLarge,
  "ithmb-small": FileImageSmall,
  "pct-large": FileImageLarge,
  "pct-small": FileImageSmall,
  "url-large": FileLinkLarge,
  "url-small": FileLinkSmall,
  "webloc-large": FileLinkLarge,
  "webloc-small": FileLinkSmall,
  "website-large": FileLinkLarge,
  "website-small": FileLinkSmall,
  "lnk-large": FileLinkLarge,
  "lnk-small": FileLinkSmall,
  "pkg-large": FilePackageLarge,
  "pkg-small": FilePackageSmall,
  "apk-large": FilePackageLarge,
  "apk-small": FilePackageSmall,
  "cgi-large": FilePackageLarge,
  "cgi-small": FilePackageSmall,
  "com-large": FilePackageLarge,
  "com-small": FilePackageSmall,
  "msi-large": FilePackageLarge,
  "msi-small": FilePackageSmall,
  "binder-large": FilePaperLarge,
  "binder-small": FilePaperSmall,
  "paper-large": FilePaperLarge,
  "paper-small": FilePaperSmall,
  "papert-large": FilePaperLarge,
  "papert-small": FilePaperSmall,
  "eps-large": FilePdfLarge,
  "eps-small": FilePdfSmall,
  "pdf-large": FilePdfLarge,
  "pdf-small": FilePdfSmall,
  "psd-large": FilePhotoshopLarge,
  "psd-small": FilePhotoshopSmall,
  "odp-large": FilePowerpointLarge,
  "odp-small": FilePowerpointSmall,
  "pps-large": FilePowerpointLarge,
  "pps-small": FilePowerpointSmall,
  "ppsm-large": FilePowerpointLarge,
  "ppsm-small": FilePowerpointSmall,
  "ppsx-large": FilePowerpointLarge,
  "ppsx-small": FilePowerpointSmall,
  "ppt-large": FilePowerpointLarge,
  "ppt-small": FilePowerpointSmall,
  "pptm-large": FilePowerpointLarge,
  "pptm-small": FilePowerpointSmall,
  "pptx-large": FilePowerpointLarge,
  "pptx-small": FilePowerpointSmall,
  "prpproj-large": FilePremiereLarge,
  "prpproj-small": FilePremiereSmall,
  "key-large": FilePresentationLarge,
  "key-small": FilePresentationSmall,
  "dlink-large": FileShortcutLarge,
  "dlink-small": FileShortcutSmall,
  "sketch-large": FileSketchLarge,
  "sketch-small": FileSketchSmall,
  "csv-large": FileSpreadsheetLarge,
  "csv-small": FileSpreadsheetSmall,
  "numbers-large": FileSpreadsheetLarge,
  "numbers-small": FileSpreadsheetSmall,
  "log-large": FileTextLarge,
  "log-small": FileTextSmall,
  "markdown-large": FileTextLarge,
  "markdown-small": FileTextSmall,
  "md-large": FileTextLarge,
  "md-small": FileTextSmall,
  "mdown-large": FileTextLarge,
  "mdown-small": FileTextSmall,
  "mkdn-large": FileTextLarge,
  "mkdn-small": FileTextSmall,
  "msg-large": FileTextLarge,
  "msg-small": FileTextSmall,
  "rtf-large": FileTextLarge,
  "rtf-small": FileTextSmall,
  "txt-large": FileTextLarge,
  "txt-small": FileTextSmall,
  "wpd-large": FileTextLarge,
  "wpd-small": FileTextSmall,
  "wps-large": FileTextLarge,
  "wps-small": FileTextSmall,
  "cue-large": FileTextLarge,
  "cue-small": FileTextSmall,
  "dat-large": FileTextLarge,
  "dat-small": FileTextSmall,
  "ged-large": FileTextLarge,
  "ged-small": FileTextSmall,
  "gpx-large": FileTextLarge,
  "gpx-small": FileTextSmall,
  "ibooks-large": FileTextLarge,
  "ibooks-small": FileTextSmall,
  "ini-large": FileTextLarge,
  "ini-small": FileTextSmall,
  "pdb-large": FileTextLarge,
  "pdb-small": FileTextSmall,
  "tex-large": FileTextLarge,
  "tex-small": FileTextSmall,
  "vcf-large": FileTextLarge,
  "vcf-small": FileTextSmall,
  "3gp-large": FileVideoLarge,
  "3gp-small": FileVideoSmall,
  "3gpp-large": FileVideoLarge,
  "3gpp-small": FileVideoSmall,
  "3gpp2-large": FileVideoLarge,
  "3gpp2-small": FileVideoSmall,
  "asf-large": FileVideoLarge,
  "asf-small": FileVideoSmall,
  "avi-large": FileVideoLarge,
  "avi-small": FileVideoSmall,
  "dv-large": FileVideoLarge,
  "dv-small": FileVideoSmall,
  "flv-large": FileVideoLarge,
  "flv-small": FileVideoSmall,
  "m2t-large": FileVideoLarge,
  "m2t-small": FileVideoSmall,
  "m4v-large": FileVideoLarge,
  "m4v-small": FileVideoSmall,
  "mkv-large": FileVideoLarge,
  "mkv-small": FileVideoSmall,
  "mov-large": FileVideoLarge,
  "mov-small": FileVideoSmall,
  "mp4-large": FileVideoLarge,
  "mp4-small": FileVideoSmall,
  "mpeg-large": FileVideoLarge,
  "mpeg-small": FileVideoSmall,
  "mpg-large": FileVideoLarge,
  "mpg-small": FileVideoSmall,
  "mts-large": FileVideoLarge,
  "mts-small": FileVideoSmall,
  "mxf-large": FileVideoLarge,
  "mxf-small": FileVideoSmall,
  "oggtheora-large": FileVideoLarge,
  "oggtheora-small": FileVideoSmall,
  "ogv-large": FileVideoLarge,
  "ogv-small": FileVideoSmall,
  "rm-large": FileVideoLarge,
  "rm-small": FileVideoSmall,
  "vob-large": FileVideoLarge,
  "vob-small": FileVideoSmall,
  "webm-large": FileVideoLarge,
  "webm-small": FileVideoSmall,
  "wmv-large": FileVideoLarge,
  "wmv-small": FileVideoSmall,
  "doc-large": FileWordLarge,
  "doc-small": FileWordSmall,
  "docm-large": FileWordLarge,
  "docm-small": FileWordSmall,
  "docx-large": FileWordLarge,
  "docx-small": FileWordSmall,
  "bz2-large": FileZipLarge,
  "bz2-small": FileZipSmall,
  "gz-large": FileZipLarge,
  "gz-small": FileZipSmall,
  "rar-large": FileZipLarge,
  "rar-small": FileZipSmall,
  "tar-large": FileZipLarge,
  "tar-small": FileZipSmall,
  "tgz-large": FileZipLarge,
  "tgz-small": FileZipSmall,
  "zip-large": FileZipLarge,
  "zip-small": FileZipSmall,
  "7z-large": FileZipLarge,
  "7z-small": FileZipSmall,
  "cbr-large": FileZipLarge,
  "cbr-small": FileZipSmall,
  "crx-large": FileZipLarge,
  "crx-small": FileZipSmall,
  "deb-large": FileZipLarge,
  "deb-small": FileZipSmall,
  "gadget-large": FileZipLarge,
  "gadget-small": FileZipSmall,
  "jar-large": FileZipLarge,
  "jar-small": FileZipSmall,
  "rpm-large": FileZipLarge,
  "rpm-small": FileZipSmall,
  "sitx-large": FileZipLarge,
  "sitx-small": FileZipSmall,
  "uue-large": FileZipLarge,
  "uue-small": FileZipSmall,
  "web-large": FileShortcutLarge,
  "web-small": FileShortcutSmall,
  "zipx-large": FileZipLarge,
  "zipx-small": FileZipSmall,
  "unknown-small": FileUnknownSmall,
  "unknown-large": FileUnknownLarge
};
export {
  EXTENSIONS_MAP
};
